import { Badge, BadgeSize } from "shared/components";
import { HugeiconsIcon } from "@hugeicons/react";
import { mapIncomeSourceStatus } from "../helpers";
import { CombinedIncome } from "../types/income";
import { cx } from "shared/utils";
import { INCOME_SOURCE_BADGE_STATUSES_MAP } from "../constants";

export const IncomeSourceStatusBadge = ({
  income,
  shouldIgnoreIcon = false,
  forceInProgress = false
}: {
  income: CombinedIncome;
  shouldIgnoreIcon?: boolean;
  forceInProgress?: boolean;
}) => {
  const { status } = mapIncomeSourceStatus(income);

  const effectiveStatus = forceInProgress ? "Started" : status || "Accepted";
  const config = INCOME_SOURCE_BADGE_STATUSES_MAP[effectiveStatus];

  if (config)
    return (
      <Badge
        variant={config.variant}
        size={BadgeSize.SM}
        className="items-center"
        leftElement={
          config.icon && !shouldIgnoreIcon ? (
            <HugeiconsIcon
              icon={config.icon}
              size={config.iconSize}
              className={cx("stroke-none", config.iconColor)}
            />
          ) : null
        }
        tooltip={config.tooltip}
      >
        {effectiveStatus === "Rejected" ? "Unverified" : config.title}
      </Badge>
    );

  return null;
};
